/**
 * @generated SignedSource<<9d266f0d1ade5bf139e0c90c3d69476f>>
 * @relayHash 73ce6c4d6441057c887150a3b1778187
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bb3d70fa0e0ccacc10627389e2a731fc98fd5fe9b19cf195cce58f9828b3b78b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSidebarMenuItemReorderOperation = "AFTER" | "BEFORE" | "MOVE_DOWN" | "MOVE_TO_BOTTOM" | "MOVE_TO_TOP" | "MOVE_UP" | "%future added value";
export type JiraReorderSidebarMenuItemInput = {
  cloudId: string;
  menuItem: JiraSidebarMenuItemInput;
  relativeMenuItem?: JiraSidebarMenuItemInput | null | undefined;
  reorderMode: JiraSidebarMenuItemReorderOperation;
};
export type JiraSidebarMenuItemInput = {
  itemId: string;
};
export type updateFavouriteOrderMutation$variables = {
  input: JiraReorderSidebarMenuItemInput;
};
export type updateFavouriteOrderMutation$data = {
  readonly jira_reorderProjectsSidebarMenuItem: {
    readonly favourites: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly projectKey: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type updateFavouriteOrderMutation = {
  response: updateFavouriteOrderMutation$data;
  variables: updateFavouriteOrderMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": isJcsProjectMenuEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarmouserelayprovider": isDragAndDropEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": isProjectActionsSyncEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarmouserelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider: {
    readonly get: () => boolean;
  };
});

import isDragAndDropEnabled_provider from '@atlassian/jira-relay-provider/src/blu-6314-drag-and-drop-projects-sidebar-mouse.relayprovider';
import isJcsProjectMenuEnabled_provider from '@atlassian/jira-relay-provider/src/jcs-project-type-m3.relayprovider';
import checkForA11YEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-aiiy-for-nav-item-sidebar.relayprovider';
import isProjectActionsSyncEnabled_provider from '@atlassian/jira-relay-provider/src/project-actions-sync-iv-llc.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  }
],
v4 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v5 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v7 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "EDIT_PROJECT_CONFIG"
  }
],
v8 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "updateFavouriteOrderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_reorderProjectsSidebarMenuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectMenuItem"
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ],
            "storageKey": "favourites(first:15)"
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarmouserelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "updateFavouriteOrderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_reorderProjectsSidebarMenuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "large"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "defaultNavigationItem",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      {
                        "alias": "editProjectConfig",
                        "args": (v7/*: any*/),
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                      },
                      {
                        "args": (v7/*: any*/),
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                      },
                      {
                        "alias": "editPermission",
                        "args": (v7/*: any*/),
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "webUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "softwareBoardCount"
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ],
            "storageKey": "favourites(first:15)"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bb3d70fa0e0ccacc10627389e2a731fc98fd5fe9b19cf195cce58f9828b3b78b",
    "metadata": {},
    "name": "updateFavouriteOrderMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjcsprojecttypem3relayprovider": isJcsProjectMenuEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcblu6314draganddropprojectssidebarmouserelayprovider": isDragAndDropEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcprojectactionssyncivllcrelayprovider": isProjectActionsSyncEnabled_provider
    }
  }
};
})();

(node as any).hash = "3fb3d322be947c54af429676ea108ccc";

export default node;
